module.exports = __webpack_public_path__ + "img/timestamp-after.c3db13fd.webp";